module.exports = __webpack_public_path__ + "img/codeOne.6b4f4287.png";